export enum GRID_CONFIG {
  CACHE_BLOCK_SIZE = 20,
  ROW_HEIGHT = 35,
  PAGE_SIZE = 20,
  HEADER_HEIGHT = 45,
  ROW_MODEL_TYPE = 'serverSide'
};
